import {
  delayConfiguration,
  startConfiguration,
  stopConfiguration,
  restartConfiguration
} from "pusher-redux";

import store from "./Store.js";
import { PUSHER } from "../../constants/pusher.js";

function createPusherOptions(data) {
  if (!(data instanceof Object)) throw new Error("invalid data type");

  return {
    cluster: data.PUSHER_CLUSTER,
    authEndpoint: data.API_URI + PUSHER.AUTH,
    encrypted: PUSHER.ENCRYPTED
  };
}

function setupPusher(start) {
  const config = store.getState().config.data;

  const result = delayConfiguration(
    store,
    config.PUSHER_KEY,
    pusher.createPusherOptions(config)
  );

  if (start) pusher.startPusher();

  return result;
}

function getAuthHeaders() {
  const tokens = store.getState().authentication.tokens;

  if (!tokens) return undefined;

  return {
    auth: {
      headers: {
        Authorization: `Bearer ${tokens.token}`
      }
    }
  };
}

function startPusher() {
  // console.log("startPusher:");
  return startConfiguration(getAuthHeaders());
}

function restartPusher() {
  // console.log("restartPusher");
  restartConfiguration(getAuthHeaders());
}

function stopPusher() {
  // console.log("stopPusher");
  stopConfiguration();
}

// using the following export pattern so we can mock more easily using jest

const pusher = {
  createPusherOptions,
  setupPusher,
  startPusher,
  stopPusher,
  restartPusher
};

export default pusher;
